import styled, { keyframes } from "styled-components";
import { FlexBox } from "@brg/ui";
import { useTranslation } from "react-i18next";
import {LayoutConst} from "../../../core";
import {FC} from "react";

const LoaderAnimation = keyframes`
0%,
100% {
  box-shadow: 0em -2.6em 0em 0em #FEFEFE, 1.8em -1.8em 0 0em #F2F2F2, 2.5em 0em 0 0em #E7E7E7, 1.75em 1.75em 0 0em #CDCDCD, 0em 2.5em 0 0em #BFBFBF, -1.8em 1.8em 0 0em #B6B6B5, -2.6em 0em 0 0em #909090, -1.8em -1.8em 0 0em #70706F;
}
12.5% {
  box-shadow: 0em -2.6em 0em 0em #70706F, 1.8em -1.8em 0 0em #FEFEFE, 2.5em 0em 0 0em #F2F2F2, 1.75em 1.75em 0 0em #E7E7E7, 0em 2.5em 0 0em #CDCDCD, -1.8em 1.8em 0 0em #BFBFBF, -2.6em 0em 0 0em #B6B6B5, -1.8em -1.8em 0 0em #909090;
}
25% {
  box-shadow: 0em -2.6em 0em 0em #909090, 1.8em -1.8em 0 0em #70706F, 2.5em 0em 0 0em #FEFEFE, 1.75em 1.75em 0 0em #F2F2F2, 0em 2.5em 0 0em #E7E7E7, -1.8em 1.8em 0 0em #CDCDCD, -2.6em 0em 0 0em #BFBFBF, -1.8em -1.8em 0 0em #B6B6B5;
}
37.5% {
  box-shadow: 0em -2.6em 0em 0em #B6B6B5, 1.8em -1.8em 0 0em #909090, 2.5em 0em 0 0em #70706F, 1.75em 1.75em 0 0em #FEFEFE, 0em 2.5em 0 0em #F2F2F2, -1.8em 1.8em 0 0em #E7E7E7, -2.6em 0em 0 0em #CDCDCD, -1.8em -1.8em 0 0em #BFBFBF;
}
50% {
  box-shadow: 0em -2.6em 0em 0em #BFBFBF, 1.8em -1.8em 0 0em #B6B6B5, 2.5em 0em 0 0em #909090, 1.75em 1.75em 0 0em #70706F, 0em 2.5em 0 0em #FEFEFE, -1.8em 1.8em 0 0em #F2F2F2, -2.6em 0em 0 0em #E7E7E7, -1.8em -1.8em 0 0em #CDCDCD;
}
62.5% {
  box-shadow: 0em -2.6em 0em 0em #CDCDCD, 1.8em -1.8em 0 0em #BFBFBF, 2.5em 0em 0 0em #B6B6B5, 1.75em 1.75em 0 0em #909090, 0em 2.5em 0 0em #70706F, -1.8em 1.8em 0 0em #FEFEFE, -2.6em 0em 0 0em #F2F2F2, -1.8em -1.8em 0 0em #E7E7E7;
}
75% {
  box-shadow: 0em -2.6em 0em 0em #E7E7E7, 1.8em -1.8em 0 0em #CDCDCD, 2.5em 0em 0 0em #BFBFBF, 1.75em 1.75em 0 0em #B6B6B5, 0em 2.5em 0 0em #909090, -1.8em 1.8em 0 0em #70706F, -2.6em 0em 0 0em #FEFEFE, -1.8em -1.8em 0 0em #F2F2F2;
}
87.5% {
  box-shadow: 0em -2.6em 0em 0em #F2F2F2, 1.8em -1.8em 0 0em #E7E7E7, 2.5em 0em 0 0em #CDCDCD, 1.75em 1.75em 0 0em #BFBFBF, 0em 2.5em 0 0em #B6B6B5, -1.8em 1.8em 0 0em #909090, -2.6em 0em 0 0em #70706F, -1.8em -1.8em 0 0em #FEFEFE;
}
`;




export const ModalWrapper = styled(FlexBox)`
    display: flex;
    place-items: center;
    justify-content: center;
`;

export const LoaderIcon = styled.div`
    font-size: 5px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: relative;
    text-indent: -9999em;
    animation: ${LoaderAnimation} 1.1s infinite ease;
    transform: translateZ(0);
`;

export const LoaderContent = styled(FlexBox)`
    flex-flow: column;
    place-items: center;
    width: 495px;
    // height: 71px;
`;

export const LoaderText = styled.span<{color?: string}>`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    letter-spacing: -0.02em;
    color: ${({color}) => color || '#FEFEFE'};

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
  }
`;
export const LoaderSpinner: FC<{color?: string, text?: string, hideText?: boolean }> = ({color, text, hideText}) => {
    const { t } = useTranslation();
    return (
        <ModalWrapper>
            <LoaderContent gy={20}>
                <LoaderIcon />
                {!hideText && <LoaderText color={color}>{text || t('project_edit.modal.load_msg')}</LoaderText>}
            </LoaderContent>
        </ModalWrapper>
    )
}

export const LoaderRotateIcon: FC = () => {
    return (
        <LoaderIcon />
    )
}
import styled, { keyframes } from "styled-components";
import { FlexBox } from "@brg/ui";
import { useTranslation } from "react-i18next";
import {LayoutConst} from "../../../core";
import {FC} from "react";

const LoaderAnimation = keyframes`
0%,
100% {
  box-shadow: 0em -2.6em 0em 0em #FEFEFE, 1.8em -1.8em 0 0em #F2F2F2, 2.5em 0em 0 0em #E7E7E7, 1.75em 1.75em 0 0em #CDCDCD, 0em 2.5em 0 0em #BFBFBF, -1.8em 1.8em 0 0em #B6B6B5, -2.6em 0em 0 0em #909090, -1.8em -1.8em 0 0em #70706F;
}
12.5% {
  box-shadow: 0em -2.6em 0em 0em #70706F, 1.8em -1.8em 0 0em #FEFEFE, 2.5em 0em 0 0em #F2F2F2, 1.75em 1.75em 0 0em #E7E7E7, 0em 2.5em 0 0em #CDCDCD, -1.8em 1.8em 0 0em #BFBFBF, -2.6em 0em 0 0em #B6B6B5, -1.8em -1.8em 0 0em #909090;
}
25% {
  box-shadow: 0em -2.6em 0em 0em #909090, 1.8em -1.8em 0 0em #70706F, 2.5em 0em 0 0em #FEFEFE, 1.75em 1.75em 0 0em #F2F2F2, 0em 2.5em 0 0em #E7E7E7, -1.8em 1.8em 0 0em #CDCDCD, -2.6em 0em 0 0em #BFBFBF, -1.8em -1.8em 0 0em #B6B6B5;
}
37.5% {
  box-shadow: 0em -2.6em 0em 0em #B6B6B5, 1.8em -1.8em 0 0em #909090, 2.5em 0em 0 0em #70706F, 1.75em 1.75em 0 0em #FEFEFE, 0em 2.5em 0 0em #F2F2F2, -1.8em 1.8em 0 0em #E7E7E7, -2.6em 0em 0 0em #CDCDCD, -1.8em -1.8em 0 0em #BFBFBF;
}
50% {
  box-shadow: 0em -2.6em 0em 0em #BFBFBF, 1.8em -1.8em 0 0em #B6B6B5, 2.5em 0em 0 0em #909090, 1.75em 1.75em 0 0em #70706F, 0em 2.5em 0 0em #FEFEFE, -1.8em 1.8em 0 0em #F2F2F2, -2.6em 0em 0 0em #E7E7E7, -1.8em -1.8em 0 0em #CDCDCD;
}
62.5% {
  box-shadow: 0em -2.6em 0em 0em #CDCDCD, 1.8em -1.8em 0 0em #BFBFBF, 2.5em 0em 0 0em #B6B6B5, 1.75em 1.75em 0 0em #909090, 0em 2.5em 0 0em #70706F, -1.8em 1.8em 0 0em #FEFEFE, -2.6em 0em 0 0em #F2F2F2, -1.8em -1.8em 0 0em #E7E7E7;
}
75% {
  box-shadow: 0em -2.6em 0em 0em #E7E7E7, 1.8em -1.8em 0 0em #CDCDCD, 2.5em 0em 0 0em #BFBFBF, 1.75em 1.75em 0 0em #B6B6B5, 0em 2.5em 0 0em #909090, -1.8em 1.8em 0 0em #70706F, -2.6em 0em 0 0em #FEFEFE, -1.8em -1.8em 0 0em #F2F2F2;
}
87.5% {
  box-shadow: 0em -2.6em 0em 0em #F2F2F2, 1.8em -1.8em 0 0em #E7E7E7, 2.5em 0em 0 0em #CDCDCD, 1.75em 1.75em 0 0em #BFBFBF, 0em 2.5em 0 0em #B6B6B5, -1.8em 1.8em 0 0em #909090, -2.6em 0em 0 0em #70706F, -1.8em -1.8em 0 0em #FEFEFE;
}
`;




export const ModalWrapper = styled(FlexBox)`
    display: flex;
    place-items: center;
    justify-content: center;
`;

export const LoaderIcon = styled.div`
    font-size: 5px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: relative;
    text-indent: -9999em;
    animation: ${LoaderAnimation} 1.1s infinite ease;
    transform: translateZ(0);
`;

export const LoaderContent = styled(FlexBox)`
    flex-flow: column;
    place-items: center;
    width: 495px;
    // height: 71px;
`;

export const LoaderText = styled.span<{color?: string}>`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    letter-spacing: -0.02em;
    color: ${({color}) => color || '#FEFEFE'};

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
  }
`;
export const LoaderSpinner: FC<{color?: string, text?: string, hideText?: boolean }> = ({color, text, hideText}) => {
    const { t } = useTranslation();
    return (
        <ModalWrapper>
            <LoaderContent gy={20}>
                <LoaderIcon />
                {!hideText && <LoaderText color={color}>{text || t('project_edit.modal.load_msg')}</LoaderText>}
            </LoaderContent>
        </ModalWrapper>
    )
}

export const LoaderRotateIcon: FC = () => {
    return (
        <LoaderIcon />
    )
}
